import { Stack } from 'expo-router';
import { PaginationProvider } from 'providers/PaginationContext';
import { SafeAreaProvider } from 'react-native-safe-area-context';

export default function PatientLayout() {
  return (
    <SafeAreaProvider>
      <PaginationProvider>
        <Stack
          screenOptions={{
            headerShown: false,
          }}
        >
          <Stack.Screen name="patient/patients" />
          <Stack.Screen name="patient/index" />
        </Stack>
      </PaginationProvider>
    </SafeAreaProvider>
  );
}
